import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

const FIREBASE_INIT_PARAMS = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
if (Object.values(FIREBASE_INIT_PARAMS).every((v) => !!v))
  firebase.initializeApp(FIREBASE_INIT_PARAMS);

type FirebaseUser = firebase.User | null;
export interface UserVerification {
  id: string;
  status?: Number;
  firebaseUser: FirebaseUser;
  supplier_id?: undefined | number;
  role: {
    name: string;
    is_admin: boolean;
    id: string;
    permissions: string[];
  };
}

export const getFirebaseUser = (): FirebaseUser => firebase.auth().currentUser;

export const getFirebaseIdToken = async (): Promise<string> => {
  const firebaseUser = getFirebaseUser();
  return !!firebaseUser ? await firebaseUser.getIdToken() : '';
};

export const firebaseSignOut = async (): Promise<void> => {
  await firebase
    .auth()
    .signOut()
    .then(() => {
      localStorage.removeItem('token');
      window.location.replace('/login');
    });
};

export const storageBucket = 'gs://shopeetw.appspot.com/';
export const storage = firebase.app().storage(storageBucket);
export const storageTaskEvent = firebase.storage.TaskEvent;

export default firebase;
